import ApiHttpClient from "@/HttpClient";
import { QueryFunctionContext } from "@tanstack/react-query";
import { WorkingPointModel } from "./Models";

export const fetchWorkingPoint = async ({ queryKey }: QueryFunctionContext) => {
  const [, workingPointId] = queryKey;
  const { data, status, statusText } = await ApiHttpClient().get<WorkingPointModel>(`/workingPoint/${workingPointId}`);

  console.log(`Status ${status} ${statusText}`);
  console.log(JSON.stringify(data, null, 4));
  return data;
}